import * as React from "react";

function PhoneFill(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props, {
    style: Object.assign({
      verticalAlign: '-0.125em'
    }, props.style),
    className: ['antd-mobile-icon', props.className].filter(Boolean).join(' ')
  }), /*#__PURE__*/React.createElement("g", {
    id: "PhoneFill-PhoneFill",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PhoneFill-\u7F16\u7EC4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "PhoneFill-\u77E9\u5F62",
    fill: "#FFFFFF",
    opacity: 0,
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1766716,31.9445426 C8.09652665,24.7479935 4.37345146,18.0644855 4.00844409,11.8899316 L4.0084441,11.8899317 C3.92661639,10.5018215 4.44249252,9.1450022 5.42588939,8.16187843 L8.87520905,4.71264482 L8.875209,4.71264487 C9.82549238,3.76245173 11.3661372,3.76245173 12.3164158,4.71264476 L17.4782284,9.87432857 L17.4782283,9.87432851 C18.4284452,10.8245882 18.4284452,12.3651945 17.4782284,13.3154495 L14.1657865,16.628821 L14.1657866,16.628821 C13.8067263,16.9875805 13.7081153,17.5315453 13.9183928,17.9935105 C15.7748593,22.0642535 17.9030566,25.2995591 20.301982,27.6984247 C22.7008932,30.097276 25.9362605,32.2254155 30.0071383,34.0818547 L30.0071383,34.0818546 C30.4691155,34.2921269 31.01309,34.1935184 31.3718619,33.8344671 L34.6853161,30.5221078 L34.685316,30.5221079 C35.6355994,29.5719147 37.1762442,29.5719147 38.1265228,30.5221078 L43.2873373,35.6837916 L43.2873374,35.6837916 C44.2375542,36.6340513 44.2375542,38.1746576 43.2873373,39.1249125 L39.83903,42.5741462 L39.8390299,42.5741463 C38.8558816,43.5575172 37.4990332,44.0733814 36.1108835,43.9915562 C29.8114647,43.6194609 22.9787453,39.7504807 15.6147216,32.3856094 L15.1766716,31.9445426 Z",
    id: "PhoneFill-\u8DEF\u5F84",
    fill: "currentColor",
    fillRule: "nonzero"
  }))));
}

export default PhoneFill;